import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ModalDirective } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ImportCratingService } from '../import-crating/services/import-crating.services';
import { TranslateService } from '@ngx-translate/core';
// import {single} from 'rxjs/operators';
// import {type} from 'os';

declare var $: any;
var that;

@Component({
  selector: 'app-import-crating',
  templateUrl: './import-crating.component.html',
  styleUrls: ['./import-crating.component.css']
})
export class ImportCratingComponent implements OnInit {

  @Output('hideImportCrating') hideImportCrating = new EventEmitter();
  @Input('batchID') batchID: any = null;
  @ViewChild('confirmImport') confirmImport: ModalDirective;
  @Output('messageCrating') messageCrating = new EventEmitter();

  numberSheet: any = null;
  numberStamp: any = null;
  isExcel: boolean = true;
  fileExcel: any;
  isLoadingFile: any = true;
  isLoadingFileSingle: any = true;
  isImport: any = false;
  activeTab = 1;
  excel: any = {};
  public messageExport: any;
  canh_bao: string = '';
  isActiveImport: boolean = false;
  stampErrors: string[] = [];

  constructor(
    private toastr: ToastrService,
    private importCratingService: ImportCratingService,
    private translate: TranslateService,
  ) {
    that = this;
  }


  ngOnInit() {
    console.log(this.isExcel)
    console.log('bactch_id', this.batchID);
    this.canh_bao = this.translate.instant('CANH_BAO_CHAM');
    this.translate.onLangChange.subscribe(() => {
      this.canh_bao = this.translate.instant('CANH_BAO_CHAM');
    });
  }

  hideCrating(event) {
    this.hideImport();
  }

  messageCrating2(event) {
    if (event == 'Done') {
      this.messageCrating.emit(this.translate.instant('SYSTEM_PROCESSING_FILE'))
      console.log('event', event)
    }
  }

  selectTab(tabNumber) {
    this.activeTab = tabNumber;
    $('#fileSelectSingle').val('');
    this.isLoadingFileSingle = false;
    if (this.isExcel) {
      this.fileExcel = null;
      this.numberStamp = null;
      this.numberSheet = null;
      $('#fileSelect').val('');
      this.excel = {};
      this.isLoadingFile = false;
    }
  }

  hideImport() {
    this.hideImportCrating.emit();
  }

  selectImport() {
    this.excel = true;
  }

  uploadFile() {
    this.confirmImport.show();
  }

  closeModalImportFile() {
    this.confirmImport.hide();
    this.reset();
  }

  reset() {
    $('#fileSelect').val('');
    $('#fileSelectSingle').val('');
    this.fileExcel = null;
    this.numberStamp = null;
    this.numberSheet = null;
    this.isLoadingFile = false;
    this.isImport = false;
    this.isActiveImport = false;
    this.stampErrors = [];
  }

  changeFileExcel(evt, type: string) {
    console.log('acgtive ', this.activeTab)
    this.isLoadingFile = true;
    this.isLoadingFileSingle = true;
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) {
      this.toastr.warning(this.translate.instant('IMPORT_CRATING_CHI_DUOC_CHON_1_FILE'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    var file = target.files['0'];
    if (file) {
      console.log('size', file.size);
      var ValidImageTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ];
      if (file.size > 1200000) {
        this.toastr.warning(this.translate.instant('IMPORT_CRATING_KICH_THUOC_FILE_QUA_LON'), '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
      if (ValidImageTypes.indexOf(file.type) < 0) {
        this.toastr.error(
          this.translate.instant('IMPORT_CRATING_DINH_DANG_FILE_KHONG_PHU_HOP'),
          '',
          {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          }
        );
        this.fileExcel = null;
        if (type === 'box') {
          $('#fileSelect').val('');
        } else {
          $('#fileSelectSingle').val('');
        }

        this.numberStamp = null;
        this.numberSheet = null;
        this.isLoadingFile = false;
        this.isLoadingFileSingle = false
        return;
      } else {
        this.fileExcel = file;
        this.isLoadingFileSingle = false
      }
    } else {
      this.toastr.warning(this.translate.instant('IMPORT_CRATING_CHUA_CO_FILE_TAI_LEN'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.isLoadingFile = false;
      this.isLoadingFileSingle = false;
    }

    if (this.fileExcel && type === 'box') {
      this.importCratingService.boxImportValidate(this.fileExcel, environment.production, this.isActiveImport).subscribe((res) => {
        if (res.code === 1) {
          this.stampErrors = res.data.stampErrors || [];
          if (res.data.totalValid > 0) {
            console.log('123123213', res.data.totalValid)
            this.numberStamp = res.data.totalRow
            this.isLoadingFile = false;
            this.isImport = true;
          } else {
            this.reset();
            this.stampErrors = res.data.stampErrors || [];
            this.toastr.error(this.translate.instant('IMPORT_CRATING_FILE_KHONG_HOP_LE'), this.canh_bao,
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              }
            );
          }
        } else {
          this.reset();
          this.toastr.error(res.message, this.canh_bao,
            {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            }
          );
        }
      },
        (error) => {
          this.reset();
          this.toastr.error(
            this.translate.instant('IMPORT_CRATING_CO_LOI_XAY_RA_KHI_TAI_LEN'),
            this.canh_bao,
            {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            }
          );
        }
      );
    }

  }

  importFile() {
    console.log('environment', environment.production)
    if (this.fileExcel) {
      console.log(10000)
      this.importCratingService.boxImport(this.fileExcel, environment.production, this.isActiveImport).subscribe((res) => {
        if (res.code == 1) {
          this.messageCrating.emit(this.translate.instant('SYSTEM_PROCESSING_FILE'))
          this.toastr.info(
            this.translate.instant('IMPORT_CRATING_TAI_LEN_THANH_CONG'),
            this.translate.instant('THONG_BAO'),
            { timeOut: 4000, positionClass: 'toast-bottom-right' }
          );
          this.reset();
          this.confirmImport.hide();
        } else {
          this.toastr.error(this.translate.instant('IMPORT_CRATING_TAI_LEN_THAT_BAI'), this.translate.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
          this.reset();
          this.confirmImport.hide();
        }
      },
        (error) => {
          this.toastr.error(
            this.translate.instant('IMPORT_CRATING_CO_LOI_XAY_RA_KHI_TAI_LEN'),
            this.canh_bao,
            {
              timeOut: 40000,
              positionClass: 'toast-bottom-right'
            }
          );
          console.log('error', error)
        })
    } else {
      this.toastr.error(this.translate.instant('IMPORT_CRATING_CHUA_CO_FILE_TAI_LEN'), this.canh_bao, {
        timeOut: 40000,
        positionClass: 'toast-bottom-right'
      });
      this.reset();
      this.confirmImport.hide();
    }
  }

  importFileSingle() {
    if (this.fileExcel) {
      console.log(10000)
      this.isLoadingFileSingle = true
      try {
        this.importCratingService.boxImportBoxSingle(this.fileExcel).subscribe((res) => {
          if (res.code == 1) {
            this.messageCrating.emit(this.translate.instant('SYSTEM_PROCESSING_FILE'))
            this.reset();
            this.confirmImport.hide();
          } else {
            this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
            this.reset();
          }
        },
          (error) => {
            this.toastr.error(
              this.translate.instant('IMPORT_CRATING_CO_LOI_XAY_RA_KHI_TAI_LEN'),
              this.canh_bao,
              {
                timeOut: 40000,
                positionClass: 'toast-bottom-right'
              }
            );
            console.log('error', error)
          })
      } catch (error) {
        console.log('error', error)
        this.isLoadingFileSingle = true
      } finally {
        this.hideImport()
      }
    } else {
      this.toastr.error(this.translate.instant('IMPORT_CRATING_CHUA_CO_FILE_TAI_LEN'), this.canh_bao, {
        timeOut: 40000,
        positionClass: 'toast-bottom-right'
      });
      this.reset();
    }
  }

  // protected readonly single = single;
  // protected readonly type = type;
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/import-crating/import-crating.component.ts